import { Check } from "lucide-react";
import { FadeUp, Eyebrow } from "@/lib/motion";

const ITEMS = [
  "Visibility with the main AI engines",
  "A simple dashboard showing updates and wins",
  "Targeting for key phrases and questions people are asking",
  "Geo targeting for keywords",
  "Peace of mind knowing you are showing up in the first pages of AI",
  "Extra oomph when combined with the full SEO program",
  "Automated billing and no-hassle pricing",
  "Agency service at a third of the cost normally",
];

export default function WhatYouGet() {
  return (
    <section className="py-20 md:py-24" data-testid="what-you-get">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <FadeUp>
          <Eyebrow>What you get</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl">
            Everything the program includes.
          </h2>
        </FadeUp>
        <ul className="mt-12 grid gap-x-12 gap-y-5 sm:grid-cols-2">
          {ITEMS.map((item, i) => (
            <FadeUp key={item} delay={0.04 * i}>
              <li
                data-testid={`what-you-get-item-${i}`}
                className="flex items-start gap-3"
              >
                <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-flame/10">
                  <Check className="h-3.5 w-3.5 text-flame" strokeWidth={3} />
                </span>
                <span className="text-lg leading-relaxed text-slate-900">
                  {item}
                </span>
              </li>
            </FadeUp>
          ))}
        </ul>
      </div>
    </section>
  );
}
